import { Controller } from '@hotwired/stimulus'
import { isVisible } from '../../../global/utils'

export default class extends Controller {
  static targets = ["countable", "counter"];
  static values = {
    labelOne: String,
    labelOther: String,
  }

  updateCount() {
    if (!this.hasCounterTarget) return

    const size = this.countableTargets.filter(isVisible).length
    // labelOne/labelOther are the server-translated plural templates
    // (e.g. "%{count} Check" / "%{count} Checks"), so updating the count
    // client-side never replaces a translation with English text.
    const template = size === 1 ? this.labelOneValue : this.labelOtherValue
    this.counterTarget.textContent = template.replace("%{count}", size)
  }
}
